const SET_AFFILIATES = "SET_AFFILIATES";
const SET_BRANDS = "SET_BRANDS";
const SET_COUNTRIES = "SET_COUNTRIES";
const SET_IS_REFERENCE_DATA_LOADED = "SET_IS_REFERENCE_DATA_LOADED";
const SET_TYPES_OF_CAMPAIGN = "SET_TYPES_OF_CAMPAIGN";
const SET_TYPES_OF_ASSETS = "SET_TYPES_OF_ASSETS";
const SET_MEDIA = "SET_MEDIA";
const SET_REQUEST_MESSAGES = "SET_REQUESTS_MESSAGES";
const SET_REQUEST_STATUS = "SET_REQUEST_STATUS";
const SET_SINGLE_REQUEST = "SET_SINGLE_REQUEST";
const SET_USER_REQUESTS = "SET_USER_REQUESTS";
const SET_UPLOAD_FILES = "SET_UPLOAD_FILES";
const SET_STATS_REQUEST = "SET_STATS_REQUEST";
const SET_GLOBAL_SETTINGS = "SET_GLOBAL_SETTINGS";
const SET_DECISION_MESSAGES = "SET_DECISION_MESSAGES";
const SET_THEMES = "SET_THEMES";

export {
    SET_AFFILIATES,
    SET_BRANDS,
    SET_COUNTRIES,
    SET_IS_REFERENCE_DATA_LOADED,
    SET_TYPES_OF_CAMPAIGN,
    SET_TYPES_OF_ASSETS,
    SET_MEDIA,
    SET_SINGLE_REQUEST,
    SET_REQUEST_MESSAGES,
    SET_REQUEST_STATUS,
    SET_THEMES,
    SET_USER_REQUESTS,
    SET_UPLOAD_FILES,
    SET_STATS_REQUEST,
    SET_GLOBAL_SETTINGS,
    SET_DECISION_MESSAGES
};
